export default {
    validation: {
        level: false,
        idKotaKab: false
    },
    option_grader: [],
    currentPage: 0,
    instruktur: [],
    mataUji: [],
    levelPeruntukan: [],
    kotaKab: [],
    modelLevelPeruntukan: [],
    formData: {
        idKategoriRpl: "da34dac4-1bac-4eb0-bcdb-00626c4d7118",
        
        instrukturSertifikasiRplRequest: [
            {
                idInstrukturRpl: "",
                instruktur: "",
                keterangan: "",
                modelMultiSelect: [],
                invalid_instruktur: false,
                nilai: "",
            },
        ],
        dokumenPendukungSertifikasiRplRequest: [
            {
                kode_dokumen: "",
                nama_dokumen: "",
                contoh_dokumen: "",
                statusUpdateFile: "",
                invalid_dokumen: false,
                idMasterDokumenPendukung: "",
                fileName: "",
            },
        ],
        dokumenPersyaratanSertifikat: [
            {
                idDokumenPendukung : "",
                idMasterDokumen: "",
                invalid_dokumen : false,
                modelMultiSelect: [],
            },
        ],
        sertifikasiRplMataUjiRequest: [
            {
                idMasterMataUji: "",
                deskripsi: "",
                batasNilai: "",
                modelMultiSelect: [],
                graderSatu: "",
                graderDua: "",
                modelGraderDua: [],
                invalid_mata_uji: false,
                modelGraderSatu: [],
            },
        ],
        kodeRpl: "",
        namaRpl: "",
        idLevel: "",
        biaya: 0,
        biayaMengulang: 0,
        tanggalDimulai: "",
        tanggalBerakhir: "",
        lokasi: "",
        idKotaKab: "",
        kategori: "",
        kategoriCpai: "",
        kapasitas: "",
        status: "",
        biayaPerMataUji: 0,
        skpTerstruktur: "",
        skpNonTerstruktur: "",
        skpAssessment: "",
        baseUrl: "",
    },
}